/* eslint-disable no-new */
/* eslint-disable no-unused-vars */
/**
 * @file Components used by all pages.
 */
import SelectorEngine from '../utils/dom/selector-engine';

import MegaNav from './MegaNav/MegaNav';
import Select from './Select';
import Carousel from './Carousel';
import CarouselV2 from './CarouselV2';
import CoachAreaResourceCard from './CoachAreaResourceCard';
import EventCardCarousel from './EventCardCarousel';
import CompareTable from './CompareTable';
import Tabs from './Tabs';
import BankCards from './BankCards';
import AddressSearch from './AddressSearch';
import SuggestionInput from './SuggestionInput';
import SelfSubmissionPlayerSearch from './SelfSubmission/SelfSubmissionPlayerSearch';
import SelfSubmissionVenueSuggestionInput from './SelfSubmission/SelfSubmissionVenueSuggestionInput';
import SelfSubmissionPlayerSuggestionInput from './SelfSubmission/SelfSubmissionPlayerSuggestionInput';
import MediaCarousel from './MediaCarousel';
import YouTubePlaylistCarousel from './YouTubePlaylistCarousel';
import SideNavigation from './SideNavigation';
import AlertBanner from './AlertBanner';
import SponsorPanel from './SponsorPanel';
import FilterPanel from './FilterPanel';
import SearchField from './SearchField';
import SearchAutocomplete from './SearchAutocomplete';
import LocationSearch from './LocationSearch/LocationSearch';
import Footer from './Footerv2';
import Footerv3 from './Footerv3/Footerv3';
import Map from './Map/Map';
import Tooltip from './Tooltip';
import CookiesModal from './CookiesModal';
import UpdateProfileForm from './UpdateProfileForm';
import CourtSearch from './CourtSearch';
import CourtSearchCompact from './CourtSearchCompact';
import LocationText from './LocationText/LocationText';
import ToggleSubmit from './ToggleSubmit';
import Toggle from './Toggle';
import FilterTimeValidation from './FilterTimeValidation';
import MapView from './Map/MapView';
import initMapBlockDemo from './MapBlock/MapBlockDemo';
import FilterPanelHorizontal from './FilterPanelHorizontal';
import ResetFilters from './ResetFilters';
import PaymentCardFields, { CARD_FIELDSET_SELECTOR } from './PaymentCardFields';
import PaymentMethodSelector from './PaymentMethodSelector';
import EarlyYearsContentModal from './EarlyYearsContentModal';

import DatePicker from './Datepicker';
import DateRangePicker from './DateRangePicker';
import DatePickerDisplay from './DatepickerDisplay';
import LoginPrompt from './LoginPrompt/LoginPrompt';
import BodyLoader from './BodyLoader';

import PlayerSearch from './PlayerSearch';
import VenueSearchV2 from './VenueSearchV2';
import NotificationCard from './NotificationCard';
import MembersAreaNavbarNew from './MembersAreaNavbarNew';
import globalCookiesBanner from './CookiesBanner';
import Accordion from './Accordion';
import SimpleLocationSearch from './SimpleLocationSearch';
import CoachNotificationBanner from './CoachNotificationBanner';
import './TextInput';
import './BackTop';
import './ContentFeedback';
import './VenueSearch';
import './SelfSubmission/SelfSubmissionVenueSearch';
// import './SelfSubmission/SelfSubmissionPlayerSearch';
import './SelfSubmission/SelfSubmissionVenueTextInput';
import './SelfSubmission/SelfSubmissionPlayerTextInput';
import './TextDOB';
import './Textarea';
import Countdown from './Countdown';
import './CopyToClipboard';
import './PrimaryNavbar';
import DigitalMediaServiceNavbar from './DigitalMediaServiceNavbar';
import './ImageUpload';
import RingProgressbar from './RingProgressbar';
import CreditoMeter from './CreditoMeter';
import './ConfirmationModalComponent';
import './PlayerDetails';
import './PlayerList';
import './ImageCropper';
import HomePageHeroBanner from './HomePageHeroBanner';
//import HomePageHeroBanner from './HomePageHeroBanner';
import { getCookie } from '../utils/cookiesManager';
import './ModalPageLayout';
import './HouseholdAddMember';
// import './Footerv2';
import { VenueSearch } from './VenueSearch';

const venueSearchEls = document.querySelectorAll('.lta-venue-search');
for (const element of venueSearchEls) {
	VenueSearch.getOrCreateInstance(element);
}

// #region - Init Select components
const selects = document.querySelectorAll('.js-lta-select:not(.lta-select--pre)');
for (const select of selects) {
	const selectComp = Select.getInstance(select) || new Select(select);
}
// #endregion

const selfSubmissionPlayerSearchEls = document.querySelectorAll('.lta-player-ss-search');
for (const element of selfSubmissionPlayerSearchEls) {
	const selfSubmissionPlayerSearch =
		SelfSubmissionPlayerSearch.getInstance(element) || new SelfSubmissionPlayerSearch(element);
}

const playerSearchEls = document.querySelectorAll('.js-singles-player-search-fav');
for (const element of playerSearchEls) {
	const playerSearch = PlayerSearch.getInstance(element) || new PlayerSearch(element);
}

const venueSearchV2Els = document.querySelectorAll('.js-venue-search-v2');
for (const element of venueSearchV2Els) {
	const venueSearchV2 = VenueSearchV2.getInstance(element) || new VenueSearchV2(element);
}

// #region - Init SuggestionInput components
const suggestionInputContainers = document.querySelectorAll('.lta-autosuggest-input');
for (const suggestionInputMainContainer of suggestionInputContainers) {
	const suggestionInputComp =
		SuggestionInput.getInstance(suggestionInputMainContainer) || new SuggestionInput(suggestionInputMainContainer);
}
// #endregion

// #region - Init SelfSubmissionVenueSuggestionInput components
const selfSubmissionVenueSuggestionInputContainers = document.querySelectorAll('.lta-ss-venue-autosuggest-input');
for (const selfSubmissionVenueSuggestionInputMainContainer of selfSubmissionVenueSuggestionInputContainers) {
	const selfSubmissionVenueSuggestionInputComp =
		SelfSubmissionVenueSuggestionInput.getInstance(selfSubmissionVenueSuggestionInputMainContainer) ||
		new SelfSubmissionVenueSuggestionInput(selfSubmissionVenueSuggestionInputMainContainer);
}
// #endregion

// #region - Init SelfSubmissionPlayerSuggestionInput components
const selfSubmissionPlayerSuggestionInputContainers = document.querySelectorAll('.lta-ss-player-autosuggest-input');
for (const selfSubmissionPlayerSuggestionInputMainContainer of selfSubmissionPlayerSuggestionInputContainers) {
	const selfSubmissionPlayerSuggestionInputComp =
		SelfSubmissionPlayerSuggestionInput.getInstance(selfSubmissionPlayerSuggestionInputMainContainer) ||
		new SelfSubmissionPlayerSuggestionInput(selfSubmissionPlayerSuggestionInputMainContainer);
}
// #endregion

// #region - Init Tabs components
const tabsMainContainers = document.querySelectorAll('.js-lta-tabs');
for (const tabsMainContainer of tabsMainContainers) {
	const tabsComp = Tabs.getInstance(tabsMainContainer) || new Tabs(tabsMainContainer);
}
// #endregion

// #region - Init CoachAreaResourceCard components
const coachAreaResourceCards = document.querySelectorAll('.js-lta-coach-area-resource-card');
for (const coachAreaResourceCard of coachAreaResourceCards) {
	const coachAreaResourceCardComp =
		CoachAreaResourceCard.getInstance(coachAreaResourceCard) || new CoachAreaResourceCard(coachAreaResourceCard);
}
// #endregion

// #region - Init MegaNav
const membersAreaNavbarNew = document.querySelector('.lta-members-area-navbar_new');
if (membersAreaNavbarNew) MembersAreaNavbarNew.getOrCreateInstance(membersAreaNavbarNew);
// #endregion

// #region - Init AddressSearch components
const addressSearchContainers = document.querySelectorAll('.lta-address-search');
for (const addressSearchElement of addressSearchContainers) {
	const addressSearchComp = AddressSearch.getInstance(addressSearchElement) || new AddressSearch(addressSearchElement);
}

const notificationCard = document.querySelectorAll('.lta-notification-card');
for (const card of notificationCard) {
	NotificationCard.getInstance(card) || new NotificationCard(card, {});
}
// #endregion

// #region - Init BankCards components
new BankCards('.js-bank-cards-default');
// #endregion

// #region - Init CompareTable components
const compareTables = document.querySelectorAll('.js-compare-table');
for (const compareTableContainer of compareTables) {
	new CompareTable(compareTableContainer, {});
}
// #endregion

// #region - Init MediaCarousel components
// Note: MediaCarousel instances for YouTubePlaylistCarousel are initialized
// dynamically when videos are loaded, so we skip initializing hidden ones here
const mediaCarousel = document.querySelectorAll('.js-lta-media-carousel');
for (const mediaCarouselElement of mediaCarousel) {
	// Skip MediaCarousel instances that are inside YouTubePlaylistCarousel content
	// These will be initialized by YouTubePlaylistCarousel after videos are loaded
	const isInYouTubeCarousel = mediaCarouselElement.closest('.lta-youtube-playlist-carousel__content');
	if (!isInYouTubeCarousel) {
		new MediaCarousel(mediaCarouselElement);
	}
}
// #endregion

// #region - Init YouTubePlaylistCarousel components
const youtubePlaylistCarousels = document.querySelectorAll('.js-lta-youtube-playlist-carousel');
for (const youtubePlaylistCarouselElement of youtubePlaylistCarousels) {
	new YouTubePlaylistCarousel(youtubePlaylistCarouselElement);
}
// #endregion

// #region - Init SideNavigation components
const sideNavElements = document.querySelectorAll('.js-side-nav');
for (const sideNavElement of sideNavElements) {
	SideNavigation.getInstance(sideNavElement) || new SideNavigation(sideNavElement, {});
}
// #endregion

// #region - Init AlertBanner components
const alertBannerContainers = document.querySelectorAll('.js-alert-banner');
for (const alertBannerContainer of alertBannerContainers) {
	AlertBanner.getInstance(alertBannerContainer) || new AlertBanner(alertBannerContainer);
}
// #endregion

// #region - Init LoginPrompt components
const loginPrompts = document.querySelectorAll('.js-login-prompt');
for (const loginPrompt of loginPrompts) {
	LoginPrompt.getInstance(loginPrompt) || new LoginPrompt(loginPrompt);
}
// #endregion

// #region - Init Duet Deatepicker
const duetDatepicker = document.querySelectorAll('duet-date-picker');
if (duetDatepicker.length > 0) {
	(async function () {
		const dayjs = await import('dayjs');
		const { DuetDatePicker } = await import('@duetds/date-picker/custom-element');
		const DATE_FORMAT = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
		customElements.define('duet-date-picker', DuetDatePicker);

		//Override localization settings and format for date picker
		for (const dateDuetElement of duetDatepicker) {
			dateDuetElement.dateAdapter = {
				parse(value = '', createDate) {
					const matches = value.match(DATE_FORMAT);
					return matches ? createDate(matches[3], matches[2], matches[1]) : '';
				},
				format(date) {
					return dayjs.default(date).format('DD-MM-YYYY');
				}
			};

			dateDuetElement.localization = {
				buttonLabel: 'Choose date',
				placeholder: 'DD-MM-YYYY',
				selectedDateMessage: 'Selected date is',
				prevMonthLabel: 'Previous month',
				nextMonthLabel: 'Next month',
				monthSelectLabel: 'Month',
				yearSelectLabel: 'Year',
				closeLabel: 'Close window',
				calendarHeading: 'Choose a date',
				dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
				monthNames: [
					'January',
					'February',
					'March',
					'April',
					'May',
					'June',
					'July',
					'August',
					'September',
					'October',
					'November',
					'December'
				],
				monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
			};
		}
	})();
}
// #endregion

// #region - Init FilterPanel components
const filterPanel = document.querySelectorAll('.js-lta-filter-panel');
for (const filterElement of filterPanel) {
	FilterPanel.getInstance(filterElement) || new FilterPanel(filterElement);
}
// #endregion

// const downloadBanner = document.querySelectorAll('.js-lta-download-banner');
// for (const downloadBannerElement of downloadBanner) {
// 	DownloadBanner.getInstance(downloadBannerElement) || new DownloadBanner(downloadBannerElement);
// }

const sponsorPanel = document.querySelectorAll('.js-official-supporters');
for (const sp of sponsorPanel) {
	SponsorPanel.getInstance(sp) || new SponsorPanel(sp, {});
}

const footerSupporter = document.querySelectorAll('.js-lta-footerv2');
for (const sp of footerSupporter) {
	Footer.getInstance(sp) || new Footer(sp, {});
}

const footerv3Elements = document.querySelectorAll('.js-lta-footerv3');
for (const element of footerv3Elements) {
	new Footerv3(element);
}

const searchField = document.querySelectorAll('.js-search-field');
for (const sf of searchField) {
	SearchField.getInstance(sf) || new SearchField(sf, {});
}

const searchAutocompleteElements = document.querySelectorAll('[data-lta-search-autocomplete]');
for (const element of searchAutocompleteElements) {
	SearchAutocomplete.getInstance(element) || new SearchAutocomplete(element);
}

const datePicker = document.querySelectorAll('.js-datepicker');
for (const sf of datePicker) {
	DatePicker.getInstance(sf) || new DatePicker(sf, {});
}

const dateRangePicker = document.querySelectorAll('.js-date-range-picker');
for (const sf of dateRangePicker) {
	DateRangePicker.getInstance(sf) || new DateRangePicker(sf, {});
}

const datePickerDisplay = document.querySelectorAll('.js-datepickerDisplay');
for (const sf of datePickerDisplay) {
	DatePickerDisplay.getInstance(sf) || new DatePickerDisplay(sf, {});
}

const courtSearch = document.querySelectorAll('.js-court-search-form');
for (const sf of courtSearch) {
	CourtSearch.getInstance(sf) || new CourtSearch(sf, {});
}

const benefitsCarousels = document.querySelectorAll('.js-benefits-carousel');
for (const carousel of benefitsCarousels) {
	const slidesPerView = Number(carousel.dataset.slidesPerView) > 0 ? Number(carousel.dataset.slidesPerView) : undefined;
	const slidesPerViewDesktop =
		Number(carousel.dataset.slidesPerViewDesktop) > 0 ? Number(carousel.dataset.slidesPerViewDesktop) : undefined;

	new Carousel(carousel, {
		breakpoints: {
			xs: { slidesPerView: slidesPerView || 2, spaceBetween: 16 },
			sm: { slidesPerView: slidesPerView || 2, spaceBetween: 16 },
			md: { slidesPerView: slidesPerView || 2, spaceBetween: 16 },
			xl: { slidesPerView: slidesPerViewDesktop || 3, spaceBetween: 24 }
		},
		infiniteLoop: false,
		slideSizing: 'min-max-width'
	});
}

const exclusiveContentCarousel = document.querySelectorAll('.js-Exclusive-Content-carousel');
for (const carousel of exclusiveContentCarousel) {
	new Carousel(carousel, {
		breakpoints: {
			xs: { slidesPerView: 1, spaceBetween: 16 },
			sm: { slidesPerView: 1, spaceBetween: 16 },
			md: { slidesPerView: 2, spaceBetween: 16 },
			xl: { slidesPerView: 4, spaceBetween: 24 }
		},
		infiniteLoop: false
	});
}

const eventCardCarouselEls = document.querySelectorAll('.js-lta-eventcard-carousel');
for (const eventCardCarousel of eventCardCarouselEls) {
	new EventCardCarousel(eventCardCarousel, {});
}
// #endregion

// #region - Init MegaNav
const megaNav = document.querySelector('.js-lta-mega-nav');
if (megaNav) MegaNav.getOrCreateInstance(megaNav);
// #endregion

// #region - Init Map
const map = document.querySelector('.js-lta-map');
if (map) Map.getOrCreateInstance(map);
// #endregion

// #region - MapBlock
if (document.querySelector('.js-map-block')) {
	initMapBlockDemo();
}


// #region - Init LocationSearch
// Places is lazy-loaded inside LocationSearch via loadPlacesLibrary()
const locationSearch = document.querySelectorAll(
	'.lta-tabpanel__panel.active .js-lta-location-search, .lta-search-field-banner .js-lta-location-search'
);
for (const ls of locationSearch) {
	LocationSearch.getOrCreateInstance(ls) || new LocationSearch(ls, {});
}
// #endregion

// #region -Tooltip
const tooltips = document.querySelectorAll('.js-lta-tooltip');
for (const tooltip of tooltips) {
	Tooltip.getInstance(tooltip) || new Tooltip(tooltip, {});
}
// #endregion

const playerAdvancedStats = SelectorEngine.findOne('[data-lta-player-advanced-stats]');
if (playerAdvancedStats) {
	// eslint-disable-next-line promise/always-return, promise/catch-or-return
	import('./PlayerStats').then(({ default: PlayerStats, NamedExport }) => {});
}
const updateProfileForm = document.querySelector('[data-lta-update-profile]');
if (updateProfileForm) {
	new UpdateProfileForm(updateProfileForm);
}

// #region - Init Loader
const bodyElement = document.querySelector('body.lta-loader');
if (bodyElement) {
	BodyLoader.getOrCreateInstance(bodyElement);
}

// #endregion

// #region - CookiesModal
const modal = document.querySelector('.js-lta-cookies-modal');
if (modal) CookiesModal.getOrCreateInstance(modal, globalCookiesBanner);
// #endregion

const courtSearchCompact = document.querySelectorAll('.js-court-search-compact');
for (const csc of courtSearchCompact) {
	CourtSearchCompact.getInstance(csc) || new CourtSearchCompact(csc, {});
}

// #region - Init LocationText
const locationText = document.querySelector('.js-geolocation-text');
if (locationText) LocationText.getOrCreateInstance(locationText);
// #endregion

// #region - Init ToggleSubmit
const toggleSubmit = document.querySelectorAll('.js-lta-court-search-toggle');
for (const tgl of toggleSubmit) {
	ToggleSubmit.getOrCreateInstance(tgl) || new ToggleSubmit(tgl, {});
}
// #endregion

// #region - Init Toggle
const toggle = document.querySelectorAll('.js-lta-toggle');
for (const tgl of toggle) {
	Toggle.getOrCreateInstance(tgl) || new Toggle(tgl, {});
}
// #endregion

// #region - Init TimeValidation
const timevalidation = document.querySelectorAll('.js-time-validation');
for (const tv of timevalidation) {
	FilterTimeValidation.getOrCreateInstance(tv) || new FilterTimeValidation(tv, {});
}
// #endregion

// #region - MapView
const mapView = document.querySelector('.js-lta-mapview');
if (mapView) MapView.getOrCreateInstance(mapView);
// #endregion

// #region - FilterPanelHorizontal
const filterHorizontal = document.querySelector('.lta-filter-panel__horizontal');
if (filterHorizontal) FilterPanelHorizontal.getOrCreateInstance(filterHorizontal);
// #endregion

// #region - ResetFilters
const resetFilters = document.querySelectorAll('.js-reset-filters');
for (const rf of resetFilters) {
	ResetFilters.getOrCreateInstance(rf) || new ResetFilters(rf, {});
}
// #endregion

// #accordion
const accordions = document.querySelectorAll('.lta-accordion');
for (const accordion of accordions) {
	Accordion.getOrCreateInstance(accordion);
}
// #endaccordion

// #region - Payment
const paymentMethodSelector = document.querySelector('.js-lta-payment');
if (paymentMethodSelector) {
	PaymentMethodSelector.getOrCreateInstance(paymentMethodSelector);
}
const cardFieldset = document.querySelector(`#${CARD_FIELDSET_SELECTOR}`);
if (cardFieldset) {
	PaymentCardFields.getOrCreateInstance(cardFieldset);
}
// #endregion

// #region - Simple location search
const simpleLocationSearch = document.querySelectorAll('.lta-simple-location-search');
for (const ls of simpleLocationSearch) {
	SimpleLocationSearch.getOrCreateInstance(ls) || new SimpleLocationSearch(ls, {});
}
// #endregion

// #region - Init DigitalMediaServiceNav
const digitalMediaServiceNavbar = document.querySelector('.lta-digital-media-service-navbar');
if (digitalMediaServiceNavbar) DigitalMediaServiceNavbar.getOrCreateInstance(digitalMediaServiceNavbar);
// #endregion

// #region - Init CoachNotificationBanner components
const coachNotificationBanners = document.querySelectorAll('.js-coach-notification-banner');
for (const coachNotificationBanner of coachNotificationBanners) {
	CoachNotificationBanner.getInstance(coachNotificationBanner) || new CoachNotificationBanner(coachNotificationBanner);
}
// #endregion

// #region - Init RingProgressbar components
const ringProgressbars = document.querySelectorAll('.js-ring-progress__wrapper');
for (const ringProgressbar of ringProgressbars) {
	RingProgressbar.getInstance(ringProgressbar) || new RingProgressbar(ringProgressbar);
}
// #endregion

// #region - Init RingProgressbar components
const creditoMeters = document.querySelectorAll('.js-creditometer__wrapper');
for (const creditoMeter of creditoMeters) {
	CreditoMeter.getInstance(creditoMeter) || new CreditoMeter(creditoMeter);
}
// #endregion

// #region - EarlyYearsContentModal
const earlyYearsContentModal = document.querySelector('#school-portal-early-access-modal');
if (earlyYearsContentModal) EarlyYearsContentModal.getOrCreateInstance(earlyYearsContentModal);
// #endregion

/* eslint-enable no-new */
/* eslint-enable no-unused-vars */

window.restartHeroBanner = () => {
	const homePageHeroBanner = document.querySelector('.js-lta-home-page-hero-banner');
	if (homePageHeroBanner) {
		const homePageHeroBannerInstance = HomePageHeroBanner.getOrCreateInstance(homePageHeroBanner);
		homePageHeroBannerInstance.restart();
	}
};

/**
 *
 */
function instanciateComponents() {
	// #region - Init HomePageHeroBanner components
	window.restartHeroBanner();
	// #endregion

	// #region - Init Carousel components
	const carousels = document.querySelectorAll('.js-lta-carousel');
	for (const carousel of carousels) {
		Carousel.getOrCreateInstance(carousel);
	}

	const carouselsv2 = document.querySelectorAll('.js-lta-carouselv2');
	for (const carousel of carouselsv2) {
		CarouselV2.getOrCreateInstance(carousel);
	}

	new Countdown();
}

instanciateComponents();

document.addEventListener('mcp_loaded', () => {
	instanciateComponents();
});

window.addEventListener('message', function (event) {
	const iframe = document.querySelector('#myIframe');

	if (!Number.isNaN(event.data) && event.data > 0) {
		iframe.style.height = event.data + 'px';
	}
});

const padelToggle = document.querySelector('.js-padel-toggle');
if (padelToggle) {
	padelToggle.addEventListener('click', () => {
		document.documentElement.classList.remove('tf');
		document.documentElement.classList.toggle('padel');
	});
}

const tfToggle = document.querySelector('.js-tf-toggle');
if (tfToggle) {
	tfToggle.addEventListener('click', () => {
		document.documentElement.classList.remove('padel');
		document.documentElement.classList.toggle('tf');
	});
}

const gtag = (...arguments_) => {
	window.dataLayer.push(arguments_);
};

const addCookiePrefrenceToDataLayer = () => {
	const cookiePrefs = getCookie('cookieprefs');
	if (cookiePrefs) {
		const decodedString = decodeURIComponent(cookiePrefs);
		const cookie = JSON.parse(decodedString);
		/**
		 *
		 */
		function gtag() {
			dataLayer.push(arguments);
		}

		try {
			gtag('consent', 'update', {
				ad_user_data: cookie.thrd === true ? 'granted' : 'denied',
				ad_personalization: cookie.thrd === true ? 'granted' : 'denied',
				ad_storage: cookie.thrd === true ? 'granted' : 'denied',
				analytics_storage: cookie.perf === true ? 'granted' : 'denied'
			});
		} catch (error) {
			console.log(error.message);
		}

		try {
			// More data send, for the GTM events to handle
			window.dataLayer.push({
				event: 'cookie-consent',
				funcCategory: cookie.func,
				perfCategory: cookie.perf,
				trgtCategory: cookie.trgt,
				thrdCategory: cookie.thrd,
				ad_storage: cookie.thrd === true ? 'granted' : 'denied',
				ad_user_data: cookie.thrd === true ? 'granted' : 'denied',
				ad_personalization: cookie.thrd === true ? 'granted' : 'denied',
				analytics_storage: cookie.perf === true ? 'granted' : 'denied'
			});
		} catch (error) {
			console.log(error.message);
		}
	}
};

// Note - There is a text node getting attached to the body on some pages from GTM script, if it exists, it should be removed.
// This is a temporary fix and should be removed when the GTM script is updated.
window.addEventListener('load', () => {
	[...document.querySelector('body').childNodes]
		?.filter(
			(element) => element.nodeName === '#text' && element.nodeValue?.toLowerCase()?.includes('page scroll')
		)?.[0]
		?.remove();

	addCookiePrefrenceToDataLayer();
});

// Note - There is a text node getting attached to the body on some pages from GTM script, if it exists, it should be removed.
// This is a temporary fix and should be removed when the GTM script is updated.
window.addEventListener('scroll', () => {
	[...document.querySelector('body').childNodes]
		?.filter(
			(element) => element.nodeName === '#text' && element.nodeValue?.toLowerCase()?.includes('page scroll')
		)?.[0]
		?.remove();
});
